import { useState, useEffect } from 'react'
import './Header.css'
import { Link } from "react-scroll"
import { FaHome, FaGraduationCap, FaBriefcase, FaProjectDiagram, FaCode, FaEnvelope, FaBlog } from 'react-icons/fa'

const navLinks = [
  { to: 'home', label: 'Home', icon: <FaHome /> },
  { to: 'educations', label: 'Education', icon: <FaGraduationCap /> },
  { to: 'careers', label: 'Career', icon: <FaBriefcase /> },
  { to: 'projects', label: 'Projects', icon: <FaProjectDiagram /> },
  { to: 'skills', label: 'Skills', icon: <FaCode /> },
  { to: 'contact', label: 'Contact', icon: <FaEnvelope /> }
]

const Header = () => {
  const [scrolled, setScrolled] = useState(false)
  const [mobile, setMobile] = useState(false)
  const [menuOpened, setMenuOpened] = useState(false)

  useEffect(() => {
    const handleResize = () => setMobile(window.innerWidth <= 768)
    const handleScroll = () => setScrolled(window.scrollY > 50)
    handleResize()
    window.addEventListener('resize', handleResize)
    window.addEventListener('scroll', handleScroll)
    return () => {
      window.removeEventListener('resize', handleResize)
      window.removeEventListener('scroll', handleScroll)
    }
  }, [])

  return (
    <nav className={`navbar ${scrolled ? 'navbar--scrolled' : ''}`}>
      <div className="navbar__inner">
        <Link to="home" spy smooth offset={-70} duration={500} className="navbar__logo-link">
          <span className="navbar__logo">pasindu.se</span>
        </Link>
        {!mobile ? (
          <ul className="navbar__links">
            {navLinks.map(({ to, label, icon }) => (
              <li key={to}>
                <Link to={to} spy smooth offset={-70} duration={500} activeClass="active">
                  <span className="navbar__icon">{icon}</span>
                  {label}
                </Link>
              </li>
            ))}
            <li>
              <a href="https://pasinduperera10.medium.com/" target="_blank" rel="noopener noreferrer">
                <span className="navbar__icon"><FaBlog /></span>
                Blog
              </a>
            </li>
          </ul>
        ) : (
          <div className="navbar__mobile">
            {menuOpened && <div className="navbar__overlay" onClick={() => setMenuOpened(false)} />}
            <button 
              className={`navbar__hamburger ${menuOpened ? 'navbar__hamburger--open' : ''}`} 
              onClick={() => setMenuOpened(!menuOpened)} 
              aria-label="Menu"
            >
              <span className="navbar__hamburger-line" />
              <span className="navbar__hamburger-line" />
              <span className="navbar__hamburger-line" />
            </button>
            <div className={`navbar__mobile-menu ${menuOpened ? 'navbar__mobile-menu--open' : ''}`}>
              <ul>
                {navLinks.map(({ to, label, icon }) => (
                  <li key={to}>
                    <Link to={to} spy smooth offset={-70} duration={500} onClick={() => setMenuOpened(false)}>
                      <span className="navbar__icon">{icon}</span>
                      {label}
                    </Link>
                  </li>
                ))}
                <li>
                  <a href="https://pasinduperera10.medium.com/" target="_blank" rel="noopener noreferrer" onClick={() => setMenuOpened(false)}>
                    <span className="navbar__icon"><FaBlog /></span>
                    Blog
                  </a>
                </li>
              </ul>
            </div>
          </div>
        )}
      </div>
    </nav>
  )
}

export default Header